import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {Message} from 'com/gongxigames/math/core/game/message/Message';
import {Session} from 'com/gongxigames/math/core/game/session/Session';
import {AbstractFilter} from './AbstractFilter';
import {Bonus} from 'com/gongxigames/math/core/game/engine/bonus/Bonus';

export class NoBonusFilter extends AbstractFilter {
    public filter(response: Message, session: Session): boolean {
        if (response.getAction() === Action.SPIN || response.getAction() === Action.FREESPIN) {
            return this.getSpin(response).bonusId === Bonus.NO_BONUS;
        }

        return true;
    }
}
